export const legacyTypes = {
  LIST_LEGACY: 'LIST_LEGACY_ASSIGNED_ITEMS',
  LIST_LEGACY_SUCCESS: 'LIST_LEGACY_ASSIGNED_ITEMS_SUCCESS',
  LIST_LEGACY_FAIL: 'LIST_LEGACY_ASSIGNED_ITEMS_FAIL',  
};
